import { AnyAction, combineReducers, Reducer } from 'redux'
import importantTripInfoReducer, {
  ImportantTripInfo,
} from './important_trip_info'
import { Destination, ShortUrlData } from './short_url'
import shortUrlReducer from './short_url'
import { UnlockPageUI } from './ui'
import unlockPageUIReducer from './ui'

export interface UnlockPageState {
  shortUrlData: ShortUrlData
  importantTripInfo: ImportantTripInfo
  ui: UnlockPageUI
}

export const UNLOCK_ORDER = 'UNLOCK_ORDER'
export const unlockOrder = (
  token: string,
  destinations: Destination[],
): AnyAction => ({ type: UNLOCK_ORDER, token, destinations })

const unlockPageReducer: Reducer<UnlockPageState> = combineReducers({
  shortUrlData: shortUrlReducer,
  importantTripInfo: importantTripInfoReducer,
  ui: unlockPageUIReducer,
})

export default unlockPageReducer
